import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  disabled?: boolean;
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false,
  disabled = false,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className={`border border-gray-200 dark:border-gray-700 rounded-lg ${className}`}>
      {/* アコーディオンヘッダー */}
      <button
        type='button'
        onClick={toggleOpen}
        disabled={disabled}
        className={`
          w-full px-4 py-3 text-left focus:outline-none focus:ring-2 focus:ring-primary-500 
          rounded-lg transition-colors duration-200
          ${
            disabled
              ? 'bg-gray-100 dark:bg-gray-700 cursor-not-allowed text-gray-500 dark:text-gray-400'
              : 'bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-white'
          }
        `}
      >
        <div className='flex items-center justify-between'>
          <span className='text-sm font-medium'>{title}</span>
          <ChevronDownIcon
            className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </div>
      </button>

      {/* アコーディオンコンテンツ */}
      {isOpen && (
        <div className='px-4 pb-4 pt-2 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-b-lg'>
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
